import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-htmlDialog',
  templateUrl: './htmlDialog.component.html',
})
export class HtmlDialogComponent implements OnInit {
  readonly ref = inject(DynamicDialogRef);
  readonly dynamicDialogConfig = inject(DynamicDialogConfig);
  private readonly sanitizer = inject(DomSanitizer);

  public htmlContent: SafeHtml = '';

  ngOnInit() {
    const updatedHtml = this.dynamicDialogConfig.data.htmlContent.replace(
      /data-highlight-colour\s*=\s*"([^"]+)"/g,
      'style="background-color: $1"',
    );

    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(updatedHtml);
  }
}
